import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterJP1: any = null,
    sceneTextLeaveJP1: any = null;
export default function JP1() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterJP1) {
                    AniContainer.removeScene(sceneTextEnterJP1);
                    sceneTextEnterJP1 = null;
                }
                if (sceneTextLeaveJP1) {
                    AniContainer.removeScene(sceneTextLeaveJP1);
                    sceneTextLeaveJP1 = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterJP1 = AniContainer.create({
                    triggerElement: '.dpu-detail-JP1',
                    triggerHook: 1,
                    offset: startH, //textTarget?.offsetHeight,
                    duration: 200, //textTarget?.offsetHeight / 2,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            return () => {
                if (sceneTextEnterJP1) {
                    AniContainer.removeScene(sceneTextEnterJP1);
                    sceneTextEnterJP1 = null;
                }
                if (sceneTextLeaveJP1) {
                    AniContainer.removeScene(sceneTextLeaveJP1);
                    sceneTextLeaveJP1 = null;
                }
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-JP1 dpu-detail-section ${css['dpu-detail-JP1']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secJP1_subtitle')}</p>
                <h2 className="title">{t('secJP1_title')}</h2>
                <p className="desc">{t('secJP1_desc')}</p>
            </div>
            <div className="card-box">
                <div className="card card1">
                    <div className="card-img">
                        <EFPicture src={'/responsive/picture/common-products/dpu_jp.png'} alt={t('secJP1_card1')} />
                    </div>
                    <p className="text">{t('secJP1_card1')}</p>
                </div>
                <div className="card-two">
                    <div className="card card2">
                        <div className="card-img">
                            <EFPicture src={'/responsive/picture/common-products/dpu_switch_jp.png'} alt={t('secJP1_card2')} />
                        </div>
                        <p className="text">{t('secJP1_card2')}</p>
                    </div>
                    <div className="card card3">
                        <div className="card-img">
                            <EFPicture src={'/responsive/picture/common-products/dpu_AC_cable.png'} alt={t('secJP1_card3')} />
                        </div>
                        <p className="text">{t('secJP1_card3')}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
